<template>
  <v-app>
    <v-content>
          <!-- menu component -->
     <!-- <menu-public></menu-public>  -->


        <v-fade-transition mode="out-in" class="top-hero">
          <router-view />
        </v-fade-transition>

    

    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    //
  })
};
</script>
<style>
  @import "https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css";
</style>
